













































































import { Prop, Component, Vue } from "vue-property-decorator";
import { Project } from "@/api/project-api";
import formatDate from "../helpers/formatDate";
import { isNewProject } from "@/preferences";
import StatusPage from "./StatusPage.vue";

@Component({
  components: {
    StatusPage
  },
  methods: {
    isNewProject
  }
})
export default class DashboardProjectItem extends Vue {
  @Prop({ required: true }) project!: Project;
  @Prop({ default: 0 }) messages!: number;
  hover = false;

  get hoverStyle() {
    if (this.hover) {
      return "background-color:rgba(33, 150, 243, 0.1);";
    } else {
      return "";
    }
  }

  get projectPagePath(): string {
    return `/projects/${this.project.projectId}`;
  }

  get createdAt() {
    return formatDate(this.project.created);
  }
}
